import React from "react";
import { Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import Landing from "./screens/Landing.jsx";
import ServicesAdmin from "./screens/ServicesAdmin";
import ServicesDesc from "./screens/ServicesDesc";
import MessagesAdmin from "./screens/MessagesAdmin";

export default function App() {
  return (
    <>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
        <link href="https://fonts.googleapis.com/css2?family=Khula:wght@400;600;800&display=swap" rel="stylesheet" />
      </Helmet>

      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/services" element={<ServicesAdmin />} />
        <Route path="/service-desc/:srvId" element={<ServicesDesc />} />
        <Route path="/messages" element={<MessagesAdmin />} />
      </Routes>
    </>
  );
}
